import { PostMessageChannel } from '@/graphql/generated/types.generated';

// The post chat thread the user currently has open and visible (a specific post + channel). Set by the
// mounted CommunicationChannel and read by NotificationsEmitControl to suppress the redundant toast for a
// thread the user is already watching live. A module singleton because the two live far apart in the tree
// and only one channel is ever mounted at a time (see CommunicationTool's tab switch).

export type OpenThread = { postId: string; channel: PostMessageChannel };

let openThread: OpenThread | null = null;

export const setOpenThread = (thread: OpenThread): void => {
    openThread = thread;
};

// Only clear if it's still the thread we registered — guards against an unmount race when switching
// channels (the new channel may register before the old one tears down).
export const clearOpenThread = (thread: OpenThread): void => {
    if (openThread && openThread.postId === thread.postId && openThread.channel === thread.channel) {
        openThread = null;
    }
};

export const getOpenThread = (): OpenThread | null => openThread;
